export enum SearchDomain {
  EVENT = 'event',
  REVIEW = 'review',
  SUBMISSION = 'submission',
  COMMITTEE = 'committee',
  CHAIR = 'chair',
  ALL = 'all'
}
